const HELP_DOCS_BASE_URL = 'https://docs.nexcess.com';

export default HELP_DOCS_BASE_URL;
